import React__default from 'react';
import { StyledImg } from './styles.js';
import { isValidURL, getCannonicalURI, formatURL, requiredHeightFromWidth, sourceSets } from './utils.js';
import { BUCKETS, SUPPORTED_DENSITIES } from './constants.js';

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/**
 * The <ResponsivePicture /> component
 * The image is rendered as a <picture /> element containing a <srcset /> for each
 * breakpoint and the actual <img /> tag
 * Browsers without picture/srcset will just render the img tag with the default fallback URI
 */

var ResponsivePicture = function ResponsivePicture(_ref) {
  var _ref$quality = _ref.quality,
      quality = _ref$quality === void 0 ? 72 : _ref$quality,
      _ref$objectFit = _ref.objectFit,
      objectFit = _ref$objectFit === void 0 ? 'contain' : _ref$objectFit,
      _ref$objectPosition = _ref.objectPosition,
      objectPosition = _ref$objectPosition === void 0 ? '50% 50%' : _ref$objectPosition,
      _ref$format = _ref.format,
      format = _ref$format === void 0 ? 'auto' : _ref$format,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? 'lazy' : _ref$loading,
      _ref$maximumDensity = _ref.maximumDensity,
      maximumDensity = _ref$maximumDensity === void 0 ? SUPPORTED_DENSITIES[SUPPORTED_DENSITIES.length - 1] : _ref$maximumDensity,
      baseURL = _ref.baseURL,
      viewportPercentages = _ref.viewportPercentages,
      fixedWidths = _ref.fixedWidths,
      height = _ref.height,
      alt = _ref.alt;
  var utilProps = {
    baseURL: baseURL,
    quality: quality,
    objectFit: objectFit,
    objectPosition: objectPosition,
    format: format,
    loading: loading,
    viewportPercentages: viewportPercentages,
    fixedWidths: fixedWidths,
    height: height,
    alt: alt,
    maximumDensity: maximumDensity
  }; // true if an error occurs while loading

  var _React$useState = React__default.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      error = _React$useState2[0],
      setError = _React$useState2[1]; // render nothing if the image is broken or failed to load
  // or if baseURL is invalid/empty


  if (error || !isValidURL(baseURL)) {
    return null;
  } // extract the source URI in case we were given a URI already transformed via the CDN


  var sourceURI = getCannonicalURI(baseURL); // get best transform for the default image which will be used if the browser does not support <picture />

  var fallbackURL = formatURL(sourceURI, BUCKETS[BUCKETS.length - 1], requiredHeightFromWidth(BUCKETS[BUCKETS.length - 1], height), 0, utilProps); // return picture/srcset/img elements

  return /*#__PURE__*/React__default.createElement("picture", null, sourceSets(sourceURI, utilProps), /*#__PURE__*/React__default.createElement(StyledImg, {
    loading: loading,
    src: fallbackURL,
    alt: alt,
    style: {
      objectFit: objectFit,
      objectPosition: objectPosition
    },
    onError: function onError() {
      return setError(true);
    }
  }));
};

export { ResponsivePicture as default };
